<template>    
    <template v-if="getMainMenu[0].length > 0 || getMainMenu[1].length > 0 || getMainMenu[2].length > 0"> 
        <div class="table-meal-plan flex-column pt-6 pb-8 px-mob px-md-6 d-flex justify-center">
            <div>
                <h2 class="mb-3 text-center">My meals</h2>
            </div>
            <!-- <div class="table-wrap">
                <ul class="d-flex justify-center">
                    <li class="mx-3 pb-2" 
                        v-for="( plan, i) in weeklyPlan" :key="i" 
                        @click="setClassActiveDay(i)" 
                        :class="{ 'active': plan.view }"
                    >
                        {{ plan.title.substring(0, 3) }}
                    </li>
                </ul>
            </div>    -->
        </div>  
        <div class="block-summary d-flex justify-center py-6 px-mob">         
            <span>                  
                <strong class="pr-4">Summary:</strong>     
                {{ countDishes( getMainMenu[0] ) }} main meal<template v-if="countDishes(getMainMenu[0]) > 1">s</template>, 
                {{ countDishes( getMainMenu[1] ) }} breakfast<template v-if="countDishes(getMainMenu[1]) > 1">s</template>,            
                {{ countDishes( getMainMenu[2] ) }} snack<template v-if="countDishes(getMainMenu[2]) > 1">s</template>
            </span>
        </div> 
    </template>  
    <template v-for="(array, index) in getMainMenu" :key="index">
            <div class="main-meals" v-if="getMainMenu[ index ].length > 0">
                <div class="main-meals-wrap">                            
                    <!-- <h2>{{ menuTitle[index] }} ({{ getMainMenu[index].length }})</h2>                -->
                    <div class="products-row mt-6">                       
                        <p class="pb-3" v-if="getMainMenu[0].count == 0">Items Not Found</p>
                        <!-- start day products -->  
                        <!-- <cardWizard :products="setSnacksProducts" category="snacks" :weeklyPlan="weeklyPlan" />                   -->
                        <div v-for="(item, i) in getMainMenu[index]" :key="i" class="product-wrap d-flex flex-row">
                            <div class="product-data d-flex">
                                <div class="product-img-wrap mr-4">
                                    <div class="product-img" 
                                        :style="{ 'background-image': `url( ${ item.dish_image } )` }" >
                                        <a :href="item.link" target="_blank"></a>                                        
                                    </div>
                                    <span class="cat-products" v-if="item.dish_type_protein">{{ item.dish_type_protein }}</span>                
                                </div>
                                <div class="product-text">
                                    <h2 class="mb-1"><a :href="item.link" target="_blank">{{ item.dish_name }}</a></h2>
                                    <ul class="d-flex product-description mb-1">
                                        <li><strong>{{ item.kcals }}</strong> Kcals</li>
                                        <li><strong>{{ item.dish_protein }}gr</strong> Protein</li>                                  
                                    </ul>
                                    <div class="quantity">Quantity: <strong>{{  item.quantity }}</strong></div>
                                    <div class="product-control-row d-flex align-center mt-auto">
                                        <div class="product-start-row d-flex">
                                            <ul class="product-start d-flex">
                                                <li class="fill-start">1</li>
                                                <li class="fill-start">2</li>
                                                <li class="fill-start">3</li>
                                                <li class="fill-start">4</li>
                                                <li class="fill-start">5</li>
                                            </ul>
                                            <p class="product-review"> ({{ item.review }}) </p>
                                        </div>            
                                    </div>    
                                </div>
                            </div>                                                 
                        </div>             
                        <!-- end day products -->
                    </div>                
                </div>
            </div>            
    </template>  
</template>

<script>
//import cardWizard from '@/components/cards/cardWizard';

export default {
    name: 'myMeals',
    props: ['editPlan', 'mainProductsAll', 'breakfastProductsAll', 'snacksProductsAll'],
    data() {
        return {
            menus: [],
            activeDay: 0,              
            menuTitle: [
                'Breakfast',
                'Main meals',
                'Snacks'
            ]
        }
    },
    methods: {
        countDishes( dishes ){
            let totalDishes = 0;

            dishes.forEach(dish => {                
                totalDishes += dish.quantity;
            });

            return totalDishes;
        },
        setClassActiveDay(i) {

            this.weeklyPlan.forEach((plan, index) => {
                plan.view = false;

                if (index === i) {
                    this.activeDay = index;
                    plan.view = true;
                }
            });

        },
        getDishes( Products, dishes, countDays ) {
            let res = [];
            let start = 0;
           
            if (dishes) {
                let step = dishes.length / countDays;                   
                this.weeklyPlan.forEach(
                    (day, i) => {
                        if (day.view == true) {
                            start = i;
                            return;
                        }
                    }
                );

                if (dishes.length > 0 && Products.length > 0) {
                   
                    for (var j = start * step; j < (start + 1) * step; j++) {
                        
                        for (var i = 0; i < Products.length; i++) { 
                                                           
                            if ( +Products[i].ID == +dishes[j].dish_id) {                                
                                res.push(Products[i]);
                            }
                        }
                    }
                }
               
                this.$store.commit('viewLoader', false);
            }
            return res;
        },
    },
    computed: { 
        countDays() {
            let week_days = 1;

            if (this.editPlan &&  this.editPlan.week_days) {
                week_days = this.editPlan.week_days;
            }
            return week_days;
        },
        weeklyPlan() {
            let plans = this.$store.getters.weeklyPlan;
            plans = plans.filter((plan, index) => (index < this.countDays));

            return plans;
        },       
        setMainProducts() {
            // let res = [];
         
            // if ( this.editPlan ) {               
            //     let dishes = this.editPlan.dishes.filter(dish => ( dish.dish_type == 'mains' || dish.dish_type == '' ) ) ?? [];
            //     // let countDays = this.editPlan.week_days ? this.editPlan.week_days : 1;         
            //     let countDays = 1;      
            //     res = this.getDishes( this.mainProductsAll, dishes, countDays ); 
            // }  

            return this.editPlan.dishes.filter(dish => (dish.dish_type == 'mains' || dish.dish_type == '')) ?? [];
        },
        setBreakfastProducts() {
            // let res = [];
                 
            // if ( this.editPlan ) {
            //     let dishes = this.editPlan.dishes.filter(dish => (dish.dish_type == 'breakfast')) ?? [];
            //     // let countDays = this.editPlan.week_days ? this.editPlan.week_days : 1;
            //     let countDays = 1;
            //     res = this.getDishes(this.breakfastProductsAll, dishes, countDays);
            // }

            return this.editPlan.dishes.filter(dish => (dish.dish_type == 'breakfast')) ?? [];
        },
        setSnacksProducts() {            
            let dishes = this.editPlan.dishes.filter(dish => (dish.dish_type == 'snacks')) ?? [];
            // let countDays = this.editPlan.week_days ? this.editPlan.week_days : 1;
            // let countDays = 1;
            // let res = this.getDishes(this.snacksProductsAll, dishes, countDays);
            return dishes;
        },
        getMainMenu() {
            console.log(this.setMainProducts);
            let menus = [
                this.setMainProducts ?? [],
                this.setBreakfastProducts ?? [],
                this.setSnacksProducts ?? []
            ];

            return menus;
        }       
    },
    async beforeMount() {
        this.$store.dispatch('getAllSettings');
    },
    watch: {  
    }
}
</script>

<style scoped  lang="stylus">
    .item-price {
        @media only screen and (max-width: 767px) {
            font-size: 25px;
        }

        @media only screen and (max-width: 500px) {
            font-size: 22px;
        }
    }
    .product-control-row {
        flex-direction: column;
    }
    .products-row {
        display: grid;
        gap: 15px;
        grid-template-columns: 1fr;
        border-bottom: none;

        &:after {
            display: none;
        }
    }
   .product-wrap {
        &:last-child .product-control-row {
            margin-bottom: 0!important;
            padding-bottom: .5rem!important;
            border-bottom: none!important;
        }
    }
    .product-control
        display: grid;
        gap: .5rem;
        width: 185px;
      
        &-row {
            border-bottom: 2px solid #E1E6EF;
        }

        & > div
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border-radius: 10px;
                width: 45px;
                height: 50px;

                span {
                    width: 25.5px;
                    height: 25px;
                    background-size: cover;
                }
                &.minus {
                    span {
                        background: url(/src/assets/images/icons/minus.svg)
                    }
                }
                &.plus {
                    span {
                        background: url(/src/assets/images/icons/plus.svg)
                    }
                }
                &.item-count
                    width: 45px;
                    height: 50px;
                    background: #FFFFFF;
                    border: 2px solid #E1E6EF;                    
                    letter-spacing: -0.02em;
                    color: #201747;
                    font-family: 'Manrope';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 24px;
                    line-height: 33px;
                &.btn-update-count
                    background: #685BC7;     
                    padding: 10px 16px; 
                    width: 45px;
                    height: 50px;
                    divansition-duration: .4s;
                    cursor: pointer 
                    &:hover
                        background: #50469a;
    #content .product-data,
    .product-data {
        .cat-products {
            position: absolute;
            bottom: 1rem;
            left: 1rem;
            color: #fff;
            font-weight: 700;
            font-size: 14px;
            padding: 0 16px;
            border-radius: 16px;
            background-color: #685BC7;
        }
        .product-img {
            width: 101.81px;
            height: 98px;
            background-size: cover;
            object-fit: cover;
            background-color: #e1e6ef;
            transition-duration: 2s;
            cursor: pointer;
            position: relative;

            &:hover {
                transform: scale(1.4);
            }
            
           &-wrap {
                border-radius: 5px;
                width: 101.81px;
                height: 98px;
                overflow: hidden;
                position: relative;

                a {
                    position: absolute;
                    width: 101.81px;
                    height: 98px;
                }
           } 
        }

        .product-text {
            width: 100%;

            h2 {
                font-family: 'Manrope', sans-serif;
                font-style: normal;
                font-weight: 700;
                font-size: 16px!important;
                line-height: 1.3;
                color: #1D2433;

                @media screen and (max-width: 500px) {
                    font-size: 14px!important;
                }

                a:visited,
                a {
                    text-decoration: none;
                    transition-duration: .4s;
                    color: #1D2433;

                    &:hover {
                        color: #2ad2c9;
                    }
                }
            }

            .product-description {
                list-style: none;
                flex-wrap: wrap;             

                li {
                    padding-right: 5px;
                    margin-right: 5px;
                    border-right: 1px solid #1D2433;
                    font-family: 'Manrope';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 12px;
                    line-height: .8;
                    white-space: nowrap; 
                    
                    @media screen and (max-width: 991px) {
                        font-size: 12px;
                    }

                    @media (max-width: 500px) {
                        margin-bottom: .5rem;
                    }

                    &:last-child {
                        border-right: none;
                        padding-right: 0;
                        margin-right: 0;
                    }
                }
            }
        }
    }
.btn-product {
    font-family: 'Manrope', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #1D2433;
    text-transform: capitalize;
    letter-spacing: normal;
    border-radius: 10px;

    &-change {
        box-shadow: none;
        border: 2px solid #E1E6EF;
        min-width: 100px;
        
        &.v-btn--disabled {
            opacity: .7!important;  
            cursor: no-drop!important;
            pointer-events: auto;   
        }
    }

}

.table-meal-plan h2 {
    z-index: 10;
}

</style>